import { Directive, ElementRef, Input } from '@angular/core';
import { OauthHelper } from '../../services'
import { JwtHelper } from 'angular2-jwt';

@Directive({
	selector: '[hasRoles]'
})
export class HasRoles {
	private _roles: string[]
	@Input() set hasRoles(roles: string){
		this._roles = roles.replace(/\s+/g, '').split(',')
	}
	constructor(private el: ElementRef, private oauthHelper: OauthHelper, private jwtHelper: JwtHelper) {
		el.nativeElement.style.display = 'none';
	}

	ngOnInit() {
		let decodedToken = this.jwtHelper.decodeToken(this.oauthHelper.getAccessToken());
		let springRoles = this._roles.map(roleName => ("ROLE_" + roleName));
		if (springRoles.every(role => decodedToken.authorities.indexOf(role) !== -1)) {
			this.el.nativeElement.style.display = '';
			return;
		}
		this.el.nativeElement.parentNode.removeChild(this.el.nativeElement);
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/hasRole/has-roles.directive.ts